import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "@env/environment";

@Injectable({providedIn: 'root'})
export class ActuatorService {

  baseUrl = environment.apiBaseUrl;
  #http = inject(HttpClient);
  #actuatorUrl = environment.apiActuatorUrl;

  healthCheck(): Observable<{ status: string }> {
    const url = `${this.#actuatorUrl}/health`;
    return this.#http.get<{ status: string }>(url);
  }
}
